<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;
    export let attributes = {};
</script>
<div class="rubric-block">{@html attributes.body}</div>
